import React from "react";

// Option label → color mapping (matches backend palette)
const PALETTE = ["#0284C7", "#059669", "#D97706", "#DC2626", "#7C3AED", "#0EA5E9"];

export const optionColor = (label = "") => {
  const k = (label || "").trim()[0]?.toUpperCase();
  if (!k) return PALETTE[0];
  const idx = k.charCodeAt(0) - "A".charCodeAt(0);
  return PALETTE[Math.abs(idx) % PALETTE.length];
};

export const OptionBadge = ({ label, size = "md", ...rest }) => {
  if (!label) return null;
  const bg = optionColor(label);
  const cls = size === "sm"
    ? "text-[10px] px-2 py-0.5"
    : "text-xs px-2.5 py-1";
  return (
    <span
      {...rest}
      className={`inline-flex items-center rounded-full font-bold text-white tracking-wider ${cls}`}
      style={{ backgroundColor: bg }}
    >
      {label}
    </span>
  );
};

export const STATUS_META = {
  draft:    { label: "Borrador",  color: "#94A3B8", bg: "#F1F5F9" },
  sent:     { label: "Enviada",   color: "#0284C7", bg: "#E0F2FE" },
  accepted: { label: "Aceptada",  color: "#059669", bg: "#D1FAE5" },
  rejected: { label: "Rechazada", color: "#DC2626", bg: "#FEE2E2" },
};

export const StatusBadge = ({ status = "draft" }) => {
  const meta = STATUS_META[status] || STATUS_META.draft;
  return (
    <span
      className="inline-flex items-center rounded-full text-[10px] font-bold uppercase tracking-widest px-2 py-0.5"
      style={{ color: meta.color, backgroundColor: meta.bg }}
    >
      {meta.label}
    </span>
  );
};
